import {
  SalaryDistributionDirectionSettingsFormDto,
  type SalaryDistributionDirectionSettingsFormInterface
} from '@zaoblako/shared/modules/document/dtos/salary-distribution/form/salary-distribution-direction-settings-form.dto';
import {
  SalaryDistributionUnitSettingsFormDto,
  type SalaryDistributionUnitSettingsFormInterface
} from '@zaoblako/shared/modules/document/dtos/salary-distribution/form/salary-distribution-unit-settings-form.dto';
import {
  SalaryDistributionFilialSettingsFormDto,
  type SalaryDistributionFilialSettingsFormInterface
} from '@zaoblako/shared/modules/document/dtos/salary-distribution/form/salary-distribution-filial-settings-form.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { DocumentDtoKeysEnum } from '@zaoblako/shared/modules/document/enums/document-dto-keys.enum';

/** Salary distribution settings */
export interface SalaryDistributionAnalyticalFeatureSettingsInterface {
  /** Direction settings for salary distribution */
  direction?: SalaryDistributionDirectionSettingsFormInterface;
  /** Unit settings for salary distribution */
  unit?: SalaryDistributionUnitSettingsFormInterface;
  /** Filial settings for salary distribution */
  filial?: SalaryDistributionFilialSettingsFormInterface;
}

/** Salary distribution settings - DTO schema */
export const SalaryDistributionAnalyticalFeatureSettingsDto = SerdeDtoClass.create<SalaryDistributionAnalyticalFeatureSettingsInterface>(
  DocumentDtoKeysEnum.SALARY_DISTRIBUTION_ANALYTICAL_FEATURE_SETTINGS_DTO,
  {
    direction: {
      label: 'Распределение БС',
      optional: context => !context?.data?.requiredAnalyticalFeatures?.directionsRequired,
      nested: SalaryDistributionDirectionSettingsFormDto,
      serializer: (_, nested) => nested,
    },
    unit: {
      label: 'Распределение БЕ',
      optional: context => !context?.data?.requiredAnalyticalFeatures?.unitsRequired,
      nested: SalaryDistributionUnitSettingsFormDto,
      serializer: (_, nested) => nested,
    },
    filial: {
      label: 'Распределение филиалов',
      optional: context => !context?.data?.requiredAnalyticalFeatures?.filialsRequired,
      nested: SalaryDistributionFilialSettingsFormDto,
      serializer: (_, nested) => nested,
    },
  },
);
